import React, { useEffect, useState } from 'react';
import { Button, Divider, Form, Input, message, Modal } from 'antd';
import { WindowWithGoogle } from '@typing/global';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import bannerimg from '../../images/brand/bannerimgs.svg';
import AddressRadioGroup from './AddressRadioGroup';
import { submitBusinessForm } from '../../actions/setup';
import { checkuser, userLogout } from '../../actions/user';
import LinkInput from './LinkInput';
import { CloseSquareFilled, EyeOutlined } from '@ant-design/icons';
import { PreviewPage } from './PreviewPage';
import RewardModalData from './RewardModalData';
import { useSelector } from 'react-redux';
import { mapUrl } from '@utils/map';
import CustomPhoneNumber from '@components/Comman/CustomPhoneNumber/CustomPhoneNumber';

interface BusinessInfo {
    contactPerson: string;
    contactNumber: string;
    address: string;
    city: string;
    state: string;
    country: string;
    pinCode: string;
}

// interface AdressdetailProps {
//     businessInfo: BusinessInfo;
//     setBusinessInfo: React.Dispatch<React.SetStateAction<BusinessInfo>>;
// }


export const Adressdetail = ({ businessInfo, setBusinessInfo, setAtiveStep }: any) => {
    const [options, setOptions] = useState<any[]>([]);
    const rewardList = useSelector((state:any)=> state?.Business?.rewardList)
    const [showPreviewModal, setShowPreviewModal] = useState(false)
    const [showRewardModal, setShowRewardModal] = useState(false)
    const [selecetdReward, setSelectedReward] = useState([])
    const [selectedAddress, setSelectedAddress] = useState('');
    const [selectedKey, setSelected] = useState(businessInfo?.selectedKey || 'graphic');
    const [link, setLink] = useState(businessInfo?.link || '');
    const [bannerPic, setBannerPic] = useState<any>(businessInfo?.bannerUrl);
    const [bannerFile, setBannerFile] = useState<any>(businessInfo?.bannerPic);
    const [contactNumber, setContactNumber] = useState(businessInfo?.contactNumber)
    const [pinCode, setPinCode] = useState('');
    const [latLong, setLatLong] = useState({
        lat: '',
        long: ''
    });
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setBusinessInfo((prevInfo: BusinessInfo) => ({
            ...prevInfo,
            [name]: value,
        }));
    };

    const handleImageChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        imageType: 'profile' | 'graphic'
      ) => {
        event.preventDefault();
        const file = event.target.files?.[0];
        if (file) {
          if (!file.type.startsWith('image/')) {
            message.error('Please upload a valid image.');
            return;
          }
      
          const reader = new FileReader();
          reader.onloadend = () => {
            const image = new Image();
            image.onload = () => {
            //   if (image.width >= 690 || image.height >= 500) {
            //     message.error('Image should be 690x500px or smaller.');
            //     return;
            //   }
      
              if (imageType === 'graphic') {
                setBannerFile(file);
                setBannerPic(reader.result);
              }
            };
            image.src = reader.result as string;
          };
          reader.readAsDataURL(file);
        }
      };

    const triggerFileUpload = () => {
        const fileInputId = 'file-upload-graphic';
        const fileInput = document.getElementById(fileInputId) as HTMLInputElement;
        if (fileInput) {
            fileInput.click();
        }
    };



    useEffect(() => {
        form.setFieldsValue({
          contactPerson: businessInfo.contactPerson,
        //   contactNumber: contactNumber,
          contactNumber: form.getFieldValue('contactNumber') || businessInfo.contactNumber,
          address: businessInfo.address,
          city: businessInfo.city,
          state: businessInfo.state,
          country: businessInfo.country,
          pinCode: pinCode || businessInfo.pinCode,
        });
        // setPinCode(businessInfo.pinCode)
        setBannerPic(businessInfo?.bannerUrl)
      }, [businessInfo]);

    const handleSelectChange = (name: string, value: any) => {
        if(name === 'pinCode') setPinCode(value)
        setBusinessInfo((prevInfo: BusinessInfo) => ({
            ...prevInfo,
            [name]: value,
        }));
    };

    // ** Load Google Maps script only once using useEffect **
    // useEffect(() => {
    //     const loadGoogleMapsScript = async () => {
    //         const script = document.createElement('script');
    //         script.src = mapUrl;
    //         script.async = true;
    //         document.body.appendChild(script);

    //         await new Promise((resolve) => (script.onload = resolve)); // Wait for script to load

    //         const input = document.getElementById('address-input') as HTMLInputElement;
    //         const autocomplete = new (window as unknown as WindowWithGoogle).google.maps.places.Autocomplete(input);

    //         autocomplete.addListener('place_changed', () => {
    //             const place = autocomplete.getPlace();
    //             if (place
    //                 && place.address_components) {
    //                 const addressComponents = place.address_components;

    //                 const newBusinessInfo = {
    //                     city: '',
    //                     state: '',
    //                     country: '',
    //                     pinCode: '',
    //                     lat: '',
    //                     long: '',
    //                 };

    //                 addressComponents.forEach((component: any) => {
    //                     const types = component.types;
    //                     if (types.includes('locality')) {
    //                         newBusinessInfo.city = component.long_name;
    //                     }
    //                     if (types.includes('administrative_area_level_1')) {
    //                         newBusinessInfo.state = component.long_name;
    //                     }
    //                     if (types.includes('postal_code')) {
    //                         newBusinessInfo.pinCode = component.long_name;
    //                         setPinCode(component.long_name);
    //                     }
    //                     if (types.includes('country')) {
    //                         newBusinessInfo.country = component.long_name;
    //                     }
    //                 });
    //                 setBusinessInfo({
    //                     ...businessInfo,
    //                     ...newBusinessInfo, // Merge the updated fields
    //                     address: place.formatted_address,
    //                     lat: place?.geometry?.location?.lat(),
    //                     long: place?.geometry?.location?.lng(),
    //                 });
    //                 setLatLong({
    //                     lat: place?.geometry?.location?.lat(),
    //                     long: place?.geometry?.location?.lng()
    //                 })
    //                 setSelectedAddress(place.formatted_address);
    //             }
    //         });
    //     };

    //     loadGoogleMapsScript();
    // }, [selectedAddress]);

    const handleSearch = (value: string) => {
        if (value) {
            setLatLong({lat: '', long: ''})
            const service = new (window as unknown as WindowWithGoogle).google.maps.places.AutocompleteService();
            service.getPlacePredictions({ input: value }, (predictions: any, status: any) => {
                if (status === (window as unknown as WindowWithGoogle).google.maps.places.PlacesServiceStatus.OK && predictions) {
                    setOptions(predictions.map((prediction: any) => ({
                        value: prediction.description,
                    })));
                } else {
                    setOptions([]);
                }
            });
        } else {
            setOptions([]);
        }
    };

    const dispatch = useDispatch();

    const onFinish = (values: any) => {
        let stepOneData = JSON.parse(localStorage.getItem('setupData'))
        const formData = {
            ...stepOneData,
            ...values,
            lat: latLong?.lat,
            long: latLong?.long,
            isSetupCompleted: true,
            selectedKey: selectedKey,
            banner: bannerFile,
            link: link,
            loader: false
        };
        // ******** will enable once required validation from frontend *********** //
        // if( selectedKey === 'address' && 
        //     (values?.state === '' || values?.pinCode === '' || values?.country === '' || latLong?.lat === '' || latLong?.long === '') ) {
        //     return message.error('Please select proper address from address dropdown with state, zip code, city and country!')
        // }
        dispatch(
            submitBusinessForm(formData, (resp: any) => {
                if (resp?.success) {
                    dispatch(checkuser((res: any) => { 
                        if(res?.status === 401) {
                            sessionStorage.removeItem('token')
                            localStorage.removeItem('token')
                            dispatch(userLogout((resp: any) => { }))
                        } else {
                            localStorage.removeItem('setupData')
                            // navigate('/dashboard')
                            setAtiveStep('3')
                        }
                    }));
                }
            })
        );
    };

    useEffect(()=> {
        setBusinessInfo({
            ...businessInfo,
            selectedKey: selectedKey,
            link: link
        })
        
    }, [selectedKey, link])

    let updatedRewardList = rewardList?.data?.map((item:any) => {
        return {
            ...item,
            label: item?.rewardName,
            value: item?.id,
        }
      })

      const handleFinishFailed =()=> {
        window.scrollTo(0,0)
      }
      
      const handleDrop = (
  e: React.DragEvent<HTMLDivElement>,
  imageType: 'profile' | 'graphic'
) => {
  e.preventDefault();
  const file = e.dataTransfer.files?.[0];
  if (!file) return;

  if (!file.type.startsWith('image/')) {
    message.error('Please upload a valid image.');
    return;
  }

  const reader = new FileReader();
  reader.onloadend = () => {
    const image = new Image();
    image.onload = () => {
      if (imageType === 'graphic') {
        setBannerFile(file);
        setBannerPic(reader.result);
      }
    };
    image.src = reader.result as string;
  };
  reader.readAsDataURL(file);
};


    return (
        <div>
            <Form 
                form={form} 
                className="formControl"
                onFinish={onFinish} 
                layout='vertical'
                initialValues={businessInfo}
                onFinishFailed={handleFinishFailed}
                >
                <div className="row">
                    <div className="col-lg-6 col-sm-12">
                        <Form.Item
                            className="formControlDesign"
                            label="Your Business Contact Person"
                            name="contactPerson"
                        >
                            <Input
                                name="contactPerson"
                                // value={businessInfo.contactPerson}
                                onChange={handleInputChange}
                            />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                       <CustomPhoneNumber isRequired={true} label="Contact Number" name="contactNumber" />
                    </div>

                    <div className="col-lg-12 col-sm-12 py-10">
                        <AddressRadioGroup showHelperText={true} selected={selectedKey} setSelected={setSelected} />
                    </div>
                    
                    <div className="col-lg-12 col-sm-12">
                        <Form.Item
                            className="formControlDesign"
                            label={<span>
                                Your Address 
                                <span className='label-helper'>(Please make sure to enter your entire address unit number, suburb, state, city, postal code and country.)</span>
                            </span>}
                            name="address"
                            layout='vertical'
                        >
                            <Input
                                // disabled={selectedKey !== 'address'}
                                id="address-input"
                                type="text"
                                placeholder="Enter your address"
                                value={selectedAddress}
                                onChange={(e) => {
                                    e.preventDefault();
                                    // handleSearch(e.target.value);
                                    setSelectedAddress(e.target.value);
                                    setBusinessInfo({ ...businessInfo, address: e.target.value });
                                  }}
                            />
                        </Form.Item>
                        {/* <span>(Please make sure to enter your entire address unit number, state, suburb, state city and country then select from the dropdown provided)</span> */}
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <Form.Item
                            className="formControlDesign"
                            label="City"
                            name="city"
                            colon={false}
                        >
                            <Input
                                // disabled={selectedKey !== 'address'}
                                placeholder="City"
                                onChange={(e) => handleSelectChange('city', e.target.value)}
                            />

                        </Form.Item>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <Form.Item
                            className="formControlDesign"
                            label="State"
                            name="state"
                            colon={false}
                        >
                            <Input
                                // disabled={selectedKey !== 'address'}
                                placeholder="State"
                                value={businessInfo.state || 'No data found'}
                            />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <Form.Item
                            className="formControlDesign"
                            label="Country"
                            name="country"
                            colon={false}
                        >
                            <Input
                                // disabled={selectedKey !== 'address'}
                                placeholder="Country"
                                value={businessInfo.country}
                                onChange={(e) => handleSelectChange('country', e.target.value)}
                            />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <Form.Item
                            className="formControlDesign"
                            label="Postal Code"
                            name="pinCode"
                            colon={false}
                        >
                            <Input
                                // disabled={selectedKey !== 'address'}
                                name="pinCode"
                                value={pinCode}
                                maxLength={6}
                                onChange={(e) => handleSelectChange('pinCode', e.target.value)}
                            />
                        </Form.Item>
                    </div>
                    
                    <Divider  variant="dashed" style={{  borderColor: '#F47523' }} dashed >Or</Divider>

                    <div className="formControlDesign">
                        <label>Address Graphic ( It will be used on marketing page in place of map )</label>
                        <div className="uploadprofileimg bannerImgs" onDragOver={(e) => e.preventDefault()}
    onDrop={(e) => handleDrop(e, 'graphic')}>
                            <div className="profile-pic-container bannerImg" style={{ height: '350px' }}>
                                <img
                                    src={bannerPic || bannerimg}
                                    alt="Banner"
                                    className="banner-pic"
                                    style={{ 
                                        width: '100%', 
                                        height: '100%',
                                        objectFit: 'contain', // Add this property 
                                    }}
                                />
                            </div>
                            <input
                                disabled={selectedKey !== 'graphic'}
                                type="file"
                                id="file-upload-graphic"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={(e) => handleImageChange(e, 'graphic')}
                            />
                            <button disabled={selectedKey !== 'graphic'} type="button" onClick={() => triggerFileUpload()} className="upload-button">
                                Upload Graphic
                            </button>
                        </div>
                    </div>

                    <Divider  variant="dashed" style={{  borderColor: '#F47523' }} dashed >Or</Divider>

                    <div className="formControlDesign">
                        <LinkInput disabled={selectedKey !== 'link'} handleChange={(value: any)=>setLink(value)} />
                    </div>

                </div>
                <div className="text-end btn-groups-Forms">
                    <Button className="btn btn-outline-primary" onClick={() => setAtiveStep('1')} >Back</Button>
                    <Button className="btn btn-outline-primary" style={{marginRight: '15px'}} onClick={() => setShowPreviewModal(true)} >
                        Preview <EyeOutlined />
                    </Button>
                    <button className="btn btn-primary" type="submit">
                      Next
                    </button>
                </div>
            </Form>
            <Modal 
                width="90vw" // Set width to 100% of the viewport
                height="90vh" // Set height to 100% of the viewport
                open={showPreviewModal} 
                footer={false}
                onCancel={()=> setShowPreviewModal(!showPreviewModal)} 
                onOk={()=> setShowPreviewModal(!showPreviewModal)} 
                // onClose={()=> setShowPreviewModal(!showPreviewModal)} 
                title="Preview Your Business Page">
                    <PreviewPage 
                        businessCode={businessInfo?.businessCode} 
                        businessName={businessInfo?.businessDetails?.businessName} 
                        referrerCode={businessInfo?.senderCode} 
                        businessData={businessInfo} 
                        logoUrl={bannerPic}
                    />
            </Modal>

            <Modal
                open={showRewardModal} 
                footer={
                    <div className="text-end btn-groups-Forms">
                        <Button className="btn btn-outline-primary" onClick={()=> setShowRewardModal(!showRewardModal)}>Cancel</Button>
                        <Button className="btn btn-primary" type="primary" onClick={()=> setShowRewardModal(!showRewardModal)}> Ok </Button>
                    </div>
                }
                onCancel={()=> setShowRewardModal(!showRewardModal)} 
                onOk={()=> setShowRewardModal(!showRewardModal)} 
                // onClose={()=> setShowRewardModal(!showRewardModal)} 
                title="Attach Reward">
                    <RewardModalData rewardList={updatedRewardList} selecetdReward={selecetdReward} setSelectedReward={setSelectedReward} />
            </Modal>
        </div>
    );

};